import SoftTypography from "components/SoftTypography";

export default function Exchange({ exchange }) {
    return (
        <SoftTypography className="table-number">
            {exchange}
        </SoftTypography>
    )
}